import { render } from "./AsesoriasWeb.vue?vue&type=template&id=b392e136&scoped=true"
import script from "./AsesoriasWeb.vue?vue&type=script&lang=js"
export * from "./AsesoriasWeb.vue?vue&type=script&lang=js"

import "./AsesoriasWeb.vue?vue&type=style&index=0&id=b392e136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b392e136"]])

export default __exports__